<template>
    <div class="add-new-main-dialog">
        <el-dialog
            :visible="isVisible"
            :title="editData.id ? '编辑考勤地点' : '新增考勤地点'"
            width="1100px"
            :close-on-click-modal='false'
            :close-on-press-escape='false'
            @close="close">
            <div class="add-main-form-box" v-loading="addNewMainLoading">
                <div class="left">
                    <!-- 地址搜索 -->
                    <div class="map-search-section">
                        <el-input
                            placeholder="请输入地址"
                            prefix-icon="el-icon-search"
                            v-model.trim="site"
                            clearable
                            size="mini"
                            @keyup.enter.native="setSite"
                            style="margin-right: 10px;width: 40%">
                        </el-input>
                        <el-button type="primary" @click="setSite" size="mini" style="margin-left:10px;">定位</el-button>
                    </div>
                    <!-- 地图展示 -->
                    <div class="map-wrapper"
                        v-loading="loading"
                        element-loading-text="正在定位当前位置"
                    >
                        <m-map ref="map" style="width: 100%; height: 400px" :config="mapConfig" @ready="handleReady">
                        </m-map>
                    </div>
                </div>

                <div class="right">
                    <!-- 坐标信息 -->
                    <div class="map-info-section">
                        <el-input size="mini" placeholder="当前选中位置" readonly v-model.trim="addressSelected">
                            <template slot="prepend">当前坐标</template>
                        </el-input>
                    </div>

                    <!-- 坐标信息 -->
                    <div class="map-info-section">
                        <el-input size="mini" placeholder="坐标信息" readonly v-model.trim="mapConfig.position">
                            <template slot="prepend">当前坐标</template>
                        </el-input>
                    </div>

                    <!-- 位置别名 -->
                    <div class="map-info-section">
                        <el-input size="mini" placeholder="请输入位置别名" v-model.trim="address">
                            <template slot="prepend">
                                位置别名
                            </template>
                        </el-input>
                    </div>

                    <!-- 打卡半径 -->
                    <div class="map-info-section">
                        <el-input size="mini" placeholder="请输入打卡半径，单位：米" type="number" v-model.trim="radius">
                            <template slot="prepend">
                                打卡半径
                            </template>
                        </el-input>
                    </div>
                </div>
            </div>

            <span slot="footer">
                <el-button size="mini" @click="close">取消</el-button>
                <el-button type="primary" size="mini" @click="confirm" :disabled="!mapConfig.position">确认</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
import { ref, reactive, inject } from '@vue/composition-api';
import MMap from '@/components/lots/siteCorrection/mMap';
import { Message } from 'element-ui';
import { createLocation, updateLocation } from '@/api/attendanceRuleSettings.js';

export default {
    components: {
        MMap
    },
    /* eslint-disable max-lines-per-function */
    setup(props, setupContext) {
        // 从父组件注入 ruleId
        const ruleId = inject('ruleId').value;
        const emit = setupContext.emit;
        // site 搜索地址
        const site = ref('');
        const map = ref(null);
        const BMap = ref(null);
        // 地图缩放级别
        const ZOOMLEVEL = 15;
        // 当前选中的地图标记
        const currentMarker = ref(null);
        // 弹窗是否打开
        const isVisible = ref(false);
        // 地图加载状态
        const loading = ref(false);
        // 位置别名
        const address = ref('');
        // 当前选中位置的地址
        const addressSelected = ref('');
        // 打卡半径
        const radius = ref('');
        // 编辑数据
        const editData = ref({});
        // 新增/更新主加载状态
        const addNewMainLoading = ref(false);
        // 当前位置
        const currentLocation = ref({
            longitude: null,
            latitude: null
        });
        // 操作类型：新增/更新
        const operaType = ref('');

        const open = (row) => {
            isVisible.value = true;
            operaType.value = row ? 'update' : 'add';
            if (row) {
                editData.value = row;
                addressSelected.value = row.address;
                address.value = row.locationName;
                radius.value = row.radius;
                mapConfig.center = { lng: row.longitude, lat: row.latitude };
                mapConfig.position = `${row.longitude},${row.latitude}`;
                setTimeout(() => {
                    setMapInfo(row.longitude, row.latitude);
                }, 100);
            } else {
                // 二次点击新增的时候，回填用户当前位置信息
                if (map.value) {
                    setTimeout(() => {
                        setMapInfo(currentLocation.value.longitude, currentLocation.value.latitude);
                    }, 100);
                }
            }
        };

        // 关闭弹窗
        const close = () => {
            isVisible.value = false;
        };

        // 地图配置
        const mapConfig = reactive({
            zoom: 15,
            center: { lng: 116.4074, lat: 39.9042 }
        });

        // 地图准备就绪
        const handleReady = ({ BMap: bmapInstance, map: mapInstance }) => {
            // 初始化地图实例和BMap对象
            BMap.value = bmapInstance;
            // 初始化地图实例
            map.value = mapInstance;

            // 默认定位到当前位置
            loading.value = true;
            // 定位用户当前位置
            const geolocation = new bmapInstance.Geolocation();
            geolocation.getCurrentPosition(function(res) {
                if (this.getStatus() === 0) {
                    // 保留用户的当前位置信息
                    currentLocation.value.longitude = res.longitude;
                    currentLocation.value.latitude = res.latitude;
                    loading.value = false;
                    // handleReady函数，这个位置只会执行一次，如果是第一次进入，而且是新增操作，才会设置地图信息
                    if (operaType.value === 'add') {
                        setMapInfo(res.longitude, res.latitude);
                    }
                } else {
                    // 定位失败时显示错误信息
                    Message.warning('定位失败，使用默认位置');
                    loading.value = false;
                }
            }, { enableHighAccuracy: true });

            // 监听地图点击事件
            mapInstance.addEventListener('click', function(e) {
                map.value.clearOverlays();
                const point = e.point;
                mapConfig.center = { lng: point.lng, lat: point.lat };
                mapConfig.position = `${point.lng},${point.lat}`;
                // 在点击位置添加标记
                addMarker(point);
                // 获取点击位置的地址信息
                getAddressInfo(point);
            });
        };

        const setMapInfo = (longitude, latitude) => {
            // 确保地图实例已初始化
            if (!BMap.value || !map.value) {
                console.error('地图实例未初始化');
                return;
            }

            // 使用传入的经纬度定位
            const point = new BMap.value.Point(longitude, latitude);

            // 更新地图配置
            mapConfig.center = { lng: longitude, lat: latitude };
            mapConfig.position = `${longitude},${latitude}`;

            // 先清空现有覆盖物
            map.value.clearOverlays();

            // 在该位置添加标记
            addMarker(point);

            // 获取该位置的地址信息
            getAddressInfo(point);
        };

        // 添加标记点
        const addMarker = (point) => {
            // 移除之前的标记
            if (currentMarker.value) {
                map.value.removeOverlay(currentMarker.value);
            }

            // 创建新标记
            const marker = new BMap.value.Marker(point);

            // 添加标记到地图
            map.value.addOverlay(marker);

            // 保存当前标记引用
            currentMarker.value = marker;

            // 设置地图中心点并缩放
            map.value.centerAndZoom(point, ZOOMLEVEL);

            // 确保地图中心点与标记点一致（冗余操作，确保生效）
            map.value.panTo(point);

            // 移除标记点击事件监听器，防止弹出信息窗口
            marker.removeEventListener('click');
        };

        // 获取地址信息
        const getAddressInfo = (point) => {
            const myGeo = new BMap.value.Geocoder();
            myGeo.getLocation(point, function(result) {
                if (result) {
                    // console.log('获取到的地理位置信息：', result);
                    site.value = result.address;
                    addressSelected.value = result.address;
                }
            });
        };

        // 定位地址
        const setSite = async () => {
            if (!site.value) return;
            try {
                // 调用地图组件的地址解析方法analysisLocal，
                // 截取用户输入地址的前3个字符作为第一个参数（快速定位区域范围（如省份或城市）），
                // 用户完整输入的地址作为第二个参数
                // 返回接收地址解析的结果
                const localResult = await setupContext.refs.map.analysisLocal(site.value.slice(0, 3), site.value);
                if (localResult) {
                    mapConfig.center = { lng: localResult.lng, lat: localResult.lat };
                    mapConfig.position = `${localResult.lng},${localResult.lat}`;
                    map.value.setZoom(ZOOMLEVEL);
                    // map.value.panTo(localResult);

                    // 使用传入的经纬度定位
                    const point = new BMap.value.Point(localResult.lng, localResult.lat);

                    // 添加标记
                    addMarker(localResult);

                    // 获取点击位置的地址信息
                    getAddressInfo(point);
                } else {
                    Message.warning('地址解析错误，请手动拖拽标记至准确位置');
                }
            } catch (error) {
                console.error('定位失败:', error);
                Message.error('定位失败，请重试');
            }
        };

        // 确认选择
        const confirm = async () => {
            if (!mapConfig.position) {
                setupContext.root.$message.warning('请先选择位置');
                return;
            }

            // 解析经纬度并转换为数字类型
            const [lng, lat] = mapConfig.position.split(',');
            const longitude = parseFloat(lng);
            const latitude = parseFloat(lat);

            // 参数验证
            if (isNaN(longitude) || isNaN(latitude)) {
                return Message.error('无效的位置信息');
            }

            const params = {
                ruleId: ruleId,
                address: addressSelected.value,
                longitude: longitude,
                latitude: latitude,
                locationName: address.value,
                radius: radius.value
            };

            // 显示加载状态
            addNewMainLoading.value = true;

            // 根据是否有id判断是新增还是编辑
            const isEdit = !!editData.value?.id;
            if (isEdit) {
                params.id = editData.value.id;
            }

            // 调用相应的API
            const res = isEdit
                ? await updateLocation(params)
                : await createLocation(params);

            if (+res.code === 0) {
                isVisible.value = false;
                addNewMainLoading.value = false;
                Message.success(isEdit ? '修改成功' : '创建成功');
                emit('finish', res.data);
            } else {
                // 处理业务错误
                addNewMainLoading.value = false;
                Message.error(res.message || (isEdit ? '修改失败' : '创建失败'));
            }
        };

        return {
            emit,
            confirm,
            site,
            mapConfig,
            handleReady,
            setSite,
            open,
            close,
            isVisible,
            loading,
            address,
            addressSelected,
            addNewMainLoading,
            editData,
            radius
        };
    }
};
</script>
<style lang="less">
.add-new-main-dialog {
    .add-main-form-box {
        width: 100%;
        box-sizing: border-box;
        display: flex;
        flex-direction: row;

        .left {
            flex: 1;
            margin-right: 10px;
        }

        .right {
            width: 320px;
            padding-top: 28px;

            .el-select {
                width: 100%;
            }
        }
    }

    .map-search-section {
        margin-bottom: 10px;
    }

    .map-wrapper {
        width: 100%;
        position: relative;
        margin: 10px 0;
        height: 400px;
    }

    .map-info-section {
        margin-top: 10px;
    }
}
</style>
